import React from "react";
import {toast} from "sonner";
import {copyToClipboard} from "../../../helpers/copyToClipboard";
import {Container, LoadingCenter} from "../../../ui";
import {Dialog} from "../../bounce-ui";
import {useIsMobile} from "../../helpers";
import {ContributionLinkResponse} from "../../declarations";
import ContributionLink from "./ContributionLink";

export interface IGenerateContributionLinkContent {
  data: ContributionLinkResponse;
  isLoading: boolean;
  totalBalance: number;
}

export const GenerateContributionLinkContent = ({data, isLoading, totalBalance}: IGenerateContributionLinkContent) => {
  const isMobile = useIsMobile();

  const handleCopyLink = () => {
    if (data) {
      copyToClipboard(data.url, isMobile);
      toast.success("Copied to clipboard successfully.");
    }
  };

  if (!data) return null;
  return (
    <Dialog
      title="Help from friends & family"
      buttonText="Copy link"
      onClick={handleCopyLink}
      secondaryButtonText="Not now"
      autoClose={false}
    >
      <Container fullWidth sx={{gap: "8px", alignItems: "start", height: "160px"}}>
        {isLoading ? (
          <LoadingCenter />
        ) : (
          <ContributionLink url={data.url} handleCopyLink={handleCopyLink} totalBalance={totalBalance} />
        )}
      </Container>
    </Dialog>
  );
};
